import { annotations } from '@esentai/core/features/questions/serializer';

import { createPageSerializer } from '@/serializers';

const serializer = createPageSerializer({
  ...annotations,
});

export default serializer;
